<template>
    <div class="wrapper ">
        <Sidebar />
        <div class="main-panel" id="main-panel">
            <Header />
            <div class="panel-header panel-header-sm">
                <canvas id="bigDashboardChart"></canvas>
            </div>
            <div class="content" style="margin-top: 20px;">
                <Loading v-if="loading === true"/>

                <div class="tabs">
                    <a style="font-weight: 500;" @click="activeTab = 1" :class="[ activeTab === 1 ? 'active' : '' ]">Active Users</a>
                    <a style="font-weight: 500;" @click="activeTab = 2" :class="[ activeTab === 2 ? 'active' : '' ]">Suspended Users</a>
                </div>

                <div v-if="activeTab === 1" id="row">
                    <div class="card">
                        <div class="card-body">
                            <h5 v-if="isSuperAdmin === true" >Pick a User</h5>
                            <v-client-table :data="activeMembers" :columns="columns" :options="activeMemberOptions">
                                <div slot="actions" slot-scope="{row}">
                                    <button @click="editMember(row)" class="transparent-button ml-3"><i class="edit-button fa fa-edit"></i> Edit</button>
                                    <button @click="suspendMember(row)" class="transparent-button"><i class="delete-button fa fa-trash"></i> Suspend</button>
                                    <button @click="resetPassword(row)" class="transparent-button"><i class="fa fa-undo"></i> Reset Password</button>
                                </div>
                            </v-client-table>
                        </div>
                    </div>
                </div>

                 <div v-else id="row">
                    <div class="card">
                        <div class="card-body">
                            <h5 v-if="isSuperAdmin === true" >Pick a User</h5>
                            <v-client-table :data="suspendedMembers" :columns="columns" :options="suspendedMemberOptions">
                                <div slot="actions" slot-scope="{row}">
                                    <button @click="editMember(row)" class="transparent-button ml-3"><i class="edit-button fa fa-edit"></i> Edit</button>
                                    <button @click="unsuspendMember(row)" class="transparent-button"><i class="green-button fa fa-reply"></i> Unsuspend</button>
                                </div>
                            </v-client-table>
                        </div>
                    </div>
                </div>

                <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
                <transition name="modal" v-if="selectedMember != null">
                    <div class="modal-mask">
                        <div class="modal-wrapper">
                            <div class="modal-container">
                                <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                                <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
                                <div class="modal-header">
                                    <slot name="header">
                                        <h3 class="mb-0">Edit User</h3>
                                    </slot>
                                </div>
                                <div class="modal-body">
                                    <slot name="body">
                                        <div class="row">
                                        <div class="col">
                                            <label>*Full Name</label>
                                            <input v-model="selectedMember.memberName" type="text" placeholder="Full Name" class="form-control"/>
                                        </div>
                                        <div class="col">
                                            <label>*Display Name</label>
                                            <input v-model="selectedMember.displayName" type="text" placeholder="Display Name" class="form-control"/>
                                        </div>
                                        <div class="col">
                                            <label>Phone Number</label>
                                            <input v-model="selectedMember.phoneNumber" type="text" placeholder="Phone Number" class="form-control"/>
                                        </div>
                                        </div>
                                        <div class="row mt-4">
                                            <div class="col-12">
                                                <label>Notes:</label>
                                                <textarea v-model="memberNote" class="form-control"/>
                                            </div>
                                        </div>
                                    </slot>
                                </div>
                                <div>
                                    <slot name="footer">
                                        <button class="btn btn-primary modal-default-button" @click="updateMember()">
                                            Update
                                        </button>
                                        <button class="btn btn-primary" @click="selectedMember = null; memberNote = '';">
                                            Close
                                        </button>
                                    </slot>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
            <Footer />
        </div>
    </div>
</template>

<script>
    import Members from '../controllers/members.controller';
    import Users from '../controllers/user.controller';
    import Notes from '../controllers/notes.controller';
    import isSuperAdmin from '../services/jwt/isSuperAdmin';

    export default {
        name: 'Listings',
        data: function() {
            return {
                activeTab: 1,
                members: {},
                columns: ['memberID', 'memberName', 'displayName', 'email', 'subscription', 'actions'],
                activeMembers: [],
                activeMemberOptions: {
                    perPage: 10,
                    pagination: { chunk: 10, dropdown: false },
                    headings: {
                        memberID: 'ID',
                        memberName: 'Name',
                        displayName: 'Display Name',
                        email: 'Email',
                        subscription: 'Subscription'
                    },
                    sortIcon: {
                        base : 'fa',
                        is: 'fa-sort',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc'
                    }
                },
                suspendedMemberOptions: {
                    perPage: 10,
                    pagination: { chunk: 10, dropdown: false },
                    headings: {
                        memberID: 'ID',
                        memberName: 'Name',
                        displayName: 'Display Name',
                        email: 'Email',
                        subscription: 'Subscription'
                    },
                    sortIcon: {
                        base : 'fa',
                        is: 'fa-sort',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc'
                    }
                },
                suspendedMembers: [],
                loading: false,
                errorMessage: '',
                successMessage: '',
                isSuperAdmin: isSuperAdmin(localStorage.getItem('superAdmin')),
                selectedMember: null,
                memberNote: ''
            }
        },

        beforeMount: async function() {
            this.loading = true;
            
            // Fetch all the information that we need for the view
            await this.getAllMembers();

            this.loading = false;
        },

        methods: {
            async getAllMembers() {
                this.loading = true;
                this.suspendedMembers = [];
                this.activeMembers = [];
                
                // Fetch all the information that we need for the view
                this.members = await Members.getAll();
                if (this.members == false ) {
                    this.errorMessage = "Something went wrong while getting the members";
                } else {
                    this.members.forEach(member => { 
                        if (member.suspended != 1) {
                            this.activeMembers.push({
                                firebaseID: member.firebase_id,
                                memberID: member.id,
                                memberName: member.name,
                                displayName: member.display_name,
                                email: member.email,
                                subscription: !member.subscribed ? "Free Plan" : "Subscribed"
                            });
                        } else {
                            this.suspendedMembers.push({
                                firebaseID: member.firebase_id,
                                memberID: member.id,
                                memberName: member.name,
                                displayName: member.display_name,
                                email: member.email,
                                subscription: !member.subscribed ? "Free Plan" : "Subscribed"
                            });
                        }
                    });
                }

                this.loading = false;
            },

            async editMember(memberInfo) {
                this.loading = true;
                this.memberNote = '';
                this.successMessage = '';
                this.errorMessage = '';
                this.selectedMember = memberInfo;
                let userNotes = await Notes.getByUserID(memberInfo.memberID);
                
                if (userNotes === false) {
                    this.errorMessage = "Something went wrong while getting the user notes"
                } else if (userNotes.error) {
                    this.errorMessage = userNotes.error;
                } else {
                    this.selectedMember.notes = userNotes[0];
                    this.memberNote = userNotes.length > 0 ? this.selectedMember.notes.note : ""; 
                }
                this.loading = false;
            },

            async suspendMember(memberInfo) {
                this.successMessage = "";
                this.errorMessage = "";

                let suspended = await Members.suspend(memberInfo.firebaseID);

                if (suspended === true) {
                    this.successMessage = "User Suspended Successfully";
                    await this.getAllMembers();
                } else {
                    this.errorMessage = "Something went wrong while suspending the user";
                }
            },

            async unsuspendMember(memberInfo) {
                this.successMessage = "";
                this.errorMessage = "";

                let suspended = await Members.unsuspend(memberInfo.firebaseID);

                if (suspended === true) {
                    this.successMessage = "User Unsuspended Successfully";
                    await this.getAllMembers();
                } else {
                    this.errorMessage = "Something went wrong while suspending the user";
                }
            },

            async resetPassword(user) {
                this.loading = true;

                this.successMessage = "";
                this.errorMessage = "";

                let userInfo = await Users.getByID(user.firebaseID);
                let emailSent = await Users.resetPassword(userInfo.email);

                if (emailSent === true) {
                    this.successMessage = "Reset password email successfully sent to member";
                } else {
                    this.errorMessage = "Something went wrong while sending reset password email";
                }

                this.loading = false;
            },

            async updateMember() {
                this.errorMessage = "";
                this.loading = true;
                let updated = await Members.update(this.selectedMember.firebaseID, this.selectedMember.memberName, this.selectedMember.displayName, this.selectedMember.phoneNumber);

                if (updated == false) {
                    this.errorMessage = "Something went wrong with updating this member"
                } else if (updated.error) {
                    this.errorMessage = updated.error;
                } else {
                    if (this.selectedMember.notes) {
                        let updated = await Notes.update(this.selectedMember.notes.id, this.memberNote);

                        if (updated == false) {
                            this.errorMessage = "Something went wrong while updating the member's note";
                        } else if (updated.error) {
                            this.errorMessage = updated.error;
                        } else {
                            this.successMessage = "Member updated successfully";
                            this.selectedMember = null;
                        }
                    } else if(!this.selectedMember.notes && this.memberNote != "") {
                        let added = await Notes.createNew(this.selectedMember.memberID, this.memberNote);

                        if (added == false) {
                            this.errorMessage = "Something went wrong while updating the member's note";
                        } else if (added.error) {
                            this.errorMessage = added.error;
                        } else {
                            this.successMessage = "Member note successfully updated";
                            this.selectedMember = null;
                        }
                    } else {
                        this.successMessage = "The member was successfully updated";
                        this.selectedMember = null;
                    }                
                }

                this.loading = false;
            }
        }
    }
</script>